import { pipe, prop } from 'ramda';
import { createSelector } from 'reselect';

import { IRootState } from '../../../../store/root.types';
import { SORT_RECOMMENDED_ID } from '../../constants/sorting.constants';
import { getDeclaredDataMinimumProductQuantity } from '../../../RecipientModule/store/statuses/statuses.selectors';

const pathToProductsState = (state: IRootState) => state.marketplace.products;

export const getIsLoading = pipe(pathToProductsState, state => state.isLoading);

export const getProducts = pipe(pathToProductsState, state => state.products);

export const getPagination = pipe(pathToProductsState, state => state.pagination);

export const getSorting = pipe(pathToProductsState, state => state.sort);

export const getFilterChips = pipe(pathToProductsState, state => state.filterChips);

export const getSearch = pipe(pathToProductsState, state => state.search);

export const getFilters = pipe(pathToProductsState, state => state.filters);

export const getHasMore = pipe(pathToProductsState, state => state.hasMore);

export const getCountryId = pipe(pathToProductsState, state => state.countryId);

export const getHasFilters = pipe(
  pathToProductsState,
  state => state.filters.giftTypes.length > 0 || state.filters.categories.length > 0 || state.filters.brands.length > 0,
);

export const getIsSearchAvailable = pipe(getSorting, sorting => sorting.id !== SORT_RECOMMENDED_ID);

const getTotalMarketplaceProductsCount = pipe(getPagination, prop('total'));

export const getIsMarketplaceEligibleForDeclaredData = createSelector(
  getTotalMarketplaceProductsCount,
  getDeclaredDataMinimumProductQuantity,
  (totalProductsCount, declaredDataMinimumProductQuantity) => totalProductsCount >= declaredDataMinimumProductQuantity,
);
